module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.11f82acc.png";